import { Component, output, inject } from '@angular/core';
import { FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';
import { IceCheckboxComponent } from '@app/shared/components/molecules/ice-checkbox/ice-checkbox.component';
import { IconNames } from '@app/shared/enums/icon-names';
import { InformationButtonComponent } from '../../../information-button/information-button.component';

@Component({
  selector: 'app-insurance-step',
  imports: [IceCheckboxComponent, ReactiveFormsModule, IceAlertComponent, InformationButtonComponent],
  templateUrl: './insurance-step.component.html',
  styleUrl: './insurance-step.component.scss',
})
export class InsuranceStepComponent {
  private formGroupDirective = inject(FormGroupDirective);

  IconNames = IconNames;

  // TODO: Rename and implement when SAPO-3977 is resolved
  whatIsAnApprovedServicePointInquired = output<boolean>();
  isWhatIsAnApprovedServicePointActive = false;

  toggleWhatIsAnApprovedServicePoint(): void {
    this.isWhatIsAnApprovedServicePointActive = !this.isWhatIsAnApprovedServicePointActive;
    this.whatIsAnApprovedServicePointInquired.emit(this.isWhatIsAnApprovedServicePointActive);
  }

  get isCustomerUsingInsurance(): FormControl {
    return this.formGroupDirective.form?.controls?.isCustomerUsingInsurance as FormControl;
  }
}
